import React from "react"
import SignUpGetHelpSuccessPage from "../components/signup-get-help-success"

export default function SignUpGetHelpSuccess() {
  return <SignUpGetHelpSuccessPage />
}
